<script>
import { VStepperHeader } from 'vuetify/lib';
export default VStepperHeader;
</script>
